
/**
 * Le nom "Button" est réservé en html, on utilise donc le nom en français pour ce composant
 */
import {defineComponent, PropType} from "vue";
import {TmsGaDto} from "../../ob1/dto/TmsGaDto";

export default defineComponent({
    name: 'Bouton',
    props: {
        label: {
            type: String,
            required: true
        },
        href: {
            type: String,
            default: ''
        },
        isPrimary: {
            type: Boolean,
            default: true
        },
        isInverse: {
            type: Boolean,
            default: false
        },
        type: {
            type: String as PropType<'button' | 'reset' | 'submit'>,
            default: 'button'
        },
        animationDuration: {
            type: Number,
            default: 4
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        isButton: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            required: false,
            default: ''
        },
        tmsCategory: {
            type: String,
            required: false,
            default: ''
        },
        tmsAction: {
            type: String,
            required: false,
            default: undefined
        },
        tmsLabel: {
            type: String,
            required: false,
            default: undefined
        }
    },
    data(): {
        buttonElement: HTMLElement | null;
        dataOb1Component: string | null;
        isAnimationRunning: boolean;
        timer: number | null;
    } {
        return {
            buttonElement: null,
            dataOb1Component: null,
            isAnimationRunning: false,
            timer: null
        };
    },
    computed: {
        classes(): Record<string, boolean | string | null> {
            const disabled = !this.isButton && this.isDisabledInternal ? "disabled" : null;
            return {
                "btn": true,
                "btn-primary": this.isPrimary,
                "btn-secondary": !this.isPrimary,
                "btn-inverse": this.isInverse,
                "disabled": disabled,
            };
        },
        isDisabledInternal(): boolean {
            if (this.isDisabled) {
                return true;
            } else {
                return this.isAnimationRunning;
            }
        },
        actionTms(): TmsGaDto {
            return {
                category: this.tmsCategory,
                action: this.tmsAction?.trim() ? toBroadbandTmsFormat(this.tmsAction) : toBroadbandTmsFormat(this.label),
                label: this.tmsLabel?.trim() ? toBroadbandTmsFormat(this.tmsLabel) : toBroadbandTmsFormat(this.href)
            }
        }
    },
    methods: {
        onClick(elt: Event): void {
            this.$emit("click", elt);
        },
        startAnimation(): void {
            if (!this.isAnimationRunning) {
                this.dataOb1Component = "ProgressBarDetermined";
                this.timer = this.animationDuration;
                this.isAnimationRunning = true;
            }
            // Permet de rafraîchir le composant afin de lancer l'animation de la barre de progression
            this.$nextTick(function () {
                (globalThis as any).ob1.Ob1Component.load(this.$el.parentElement);
            });
        },
        stopAnimation(): void {
            if (!this.isAnimationRunning) {
                return;
            }
            const el = this.$refs.buttonElement as HTMLElement;
            if (!this.isDisabled) {
                el.removeAttribute("disabled");
            }
            (el as any).ProgressBarDetermined("progressBarInButtonReinitialisation");
            this.dataOb1Component = null;
            this.timer = null;
            this.isAnimationRunning = false;
        }
    }
});
